import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { PrimaryButton } from 'components/Button';
import { translate } from 'helpers/intl';
import { IntlShape, injectIntl } from 'react-intl';
import { sanlamAccentGrey } from 'Material-UI/colors';
import { mapsUrl } from 'utils/globalConst';
import { StyledCaptions } from './style';
import messages from './messages';

const HelpBox = (props: { intl: IntlShape }) => {
  const handleClick = () => {
    window.open(mapsUrl);
  };

  return (
    <React.Fragment>
      <Box paddingX={[4, 8, 12]} marginTop={2}>
        <Grid container>
          <Grid item xs={12}>
            <PrimaryButton variant="outlined" onClick={handleClick}>
              {translate({ ...messages.agentLocation }, props)}
            </PrimaryButton>
          </Grid>
          <Grid item xs={12}>
            <StyledCaptions color={sanlamAccentGrey}>
              {translate({ ...messages.helpMessage }, props)}
            </StyledCaptions>
          </Grid>
        </Grid>
      </Box>
    </React.Fragment>
  );
};

export default injectIntl(HelpBox);
